<template>
  <div class="row" style="height:100vh; justify-content:center; align-items:center;">
    <div class="col-lg-5 col-md-7">
      <div class="card shadow border-0">
        <div class="card-body px-lg-5 py-lg-5">
          <div class="card-title text-center">
            <img src="/img/brand/prism_logo.png" alt="Prism logo" width="165" height="150">
            <h3 class="text-muted mt-2">Net Zero Analytics</h3>
          </div>
          <div role="form">
            <base-alert
              v-if="errorMsg !== ''"
              type="danger"
            >
            <template v-slot>
              {{ errorMsg }}
            </template>
            </base-alert>

            <base-input
              formClasses="input-group-alternative mb-3"
              inputClasses="form-control-lg"
              placeholder="Email"
              addon-left-icon="tim-icons icon-email-85"
              @input="email = $event.trim()"
            >
            </base-input>

            <base-input
              formClasses="input-group-alternative mb-3"
              inputClasses="form-control-lg"
              placeholder="Password"
              type="password"
              addon-left-icon="tim-icons icon-key-25"
              @input="password = $event.trim()"
            >
            </base-input>

            <div class="text-center">
              <base-button @buttonClicked="login" type="primary" class="my-4">Sign&nbsp;in</base-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "../api";
export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      errorMsg: "",
    };
  },
  methods: {
    login () {
      if (this.email === "" || this.password === "") {
        return false;
      }  
      Api.send("POST", "/user/login", {email: this.email, password: this.password})
      .then((response) => {
        this.errorMsg = "";
        this.$root.setLoggedUser(response.data);
        if (this.$root.canUserDo(['prism_access'])) {
          this.$router.push({name: 'dashboard'})
        } else {
          this.$root.deleteLoggedUser();
        }
      })
      .catch((err) => {
        this.errorMsg = err.msg;
      });
    },
  },
};
</script>
<style></style>
